// Components/HomePage/FinalCTA.jsx
import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const staggerContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const fadeUp = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

export default function FinalCTA() {
  return (
    <section className="px-4 md:px-6 bg-white py-16 md:py-12">
      <div className="max-w-4xl mx-auto">

        {/* CTA BOX */}
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0 }}
          className="rounded-3xl bg-gradient-to-r from-gray-950 via-gray-900 to-gray-800 px-8 py-8 md:px-12 md:py-10 shadow-2xl text-center"
        >
          {/* HEADING */}
          <motion.h2
            variants={fadeUp}
            className="text-3xl md:text-3xl lg:text-5xl font-bold mb-4 text-white"
          >
            Where Experience Meets Execution
          </motion.h2>

          {/* DESCRIPTION */}
          <motion.p
            variants={fadeUp}
            className="text-sm text-gray-300 mt-6 max-w-xl mx-auto mb-6"
          >
            We specialize in complex, high-value projects — custom homes, ADUs,
            HOA reconstruction, and full remodels. Trusted by homeowners,
            investors, and HOAs across California. Let's build something that
            lasts generations.
          </motion.p>

          {/* BUTTON */}
          <motion.div variants={fadeUp}>
            <Link to="/contact">
              <button
                type="button"
                className="bg-[#e9ecef] hover:bg-[#dee2e6] text-[#212529] font-semibold py-3 px-8 text-base md:text-lg rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105"
              >
                Start Your Project
              </button>
            </Link>
          </motion.div>

          {/* BOTTOM TEXT */}
          <motion.p
            variants={fadeUp}
            className="text-sm text-gray-300 mt-6 max-w-xl mx-auto"
          >
            Built with integrity. Delivered with structure. From rough to
            perfect — every time.
          </motion.p>

        </motion.div>
      </div>
    </section>
  );
}